/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from 'react'
import axios from 'axios';
import jwt_decode from "jwt-decode";
import Navbar from "../../Navbar";
import Header from "../../Header";
import baseUrl from "../../BaseUrl";
import Loader from "../../Loader";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Pagination from "react-js-pagination";
import { useNavigate, Link, useLocation } from 'react-router-dom';
import * as XLSX from 'xlsx'; // Import the xlsx library

 
const CallPassBrandedCallingDetails = () => {
    const location = useLocation();
    const { initialFilters } = location.state || {};
    const [name, setName] = useState('');
    const [token, setToken] = useState('');
    const [cid, setCid] = useState('');
    const [expire, setExpire] = useState('');  
    const [role, setRole] = useState('');
    const [access, setAccess] = useState([]);
    const [popupOpen, setPopupOpen] = useState(false);
    const [loadingCount, setLoadingCount] = useState(0);
    const [callPassBrandedCallingAccess, setCallPassBrandedCallingAccess] = useState(false);
    const [userCallPassBrandedCallingAccess, setUserCallPassBrandedCallingAccess] = useState(false);
    const [company, setCompany] = useState([]);
    const [page, setPage] = useState(1);
    const [totalItem, setTotalItem] = useState(0);
    const [timeZone, seTimeZone] = useState('');
    const [displayTimezone, setDisplayTimezone] = useState(initialFilters?.displayTimezone || 'UTC');
    const [pendingDisplayTimezone, setPendingDisplayTimezone] = useState(initialFilters?.displayTimezone || 'UTC');

    const navigate = useNavigate();

    // Date and Time range filters
    const getYesterday = () => {
        const today = new Date();
        const yesterday = new Date(today);
        yesterday.setDate(today.getDate() - 1);
        return yesterday;
    };
    // Initialize filter states:
    // 1. From 'initialFilters' if present (e.g., coming from Details page).
    // 2. Else, use default values.
    const [startDate, setStartDate] = useState(
        initialFilters?.startDate ? new Date(initialFilters.startDate) : getYesterday()
    );
    const [endDate, setEndDate] = useState(
        initialFilters?.endDate ? new Date(initialFilters.endDate) : new Date()
    );
    const [startTime, setStartTime] = useState(initialFilters?.startTime || "00:00");
    const [endTime, setEndTime] = useState(initialFilters?.endTime || "23:59");
    const [selectedCompany, setSelectedCompany] = useState(initialFilters?.selectedCompany || "");

    // Other filters
    const [selectedEntity, setSelectedEntity] = useState(initialFilters?.selectedEntity || "");
    const [selectedDisplayIdentity, setSelectedDisplayIdentity] = useState(initialFilters?.selectedDisplayIdentity || "");
    const [selectedOrigationNumber, setSelectedOrigationNumber] = useState(initialFilters?.selectedOrigationNumber || "");

    // Options for filters (to be fetched from API)
    const [entityOptions, setEntityOptions] = useState([]);
    const [displayIdentityOptions, setDisplayIdentityOptions] = useState([]);
    const [origationNumberOptions, setOrigationNumberOptions] = useState([]);

    // Summary Data
    const [summaryData, setSummaryData] = useState([]);

    // Refs to skip initial mount for certain useEffects
    const isInitialMountEntity = useRef(true);
    const isInitialMountDisplayIdentity = useRef(true);
    const isInitialMountOrigationNumber = useRef(true);
    const isInitialPageLoadForAutoApply = useRef(true); // Ref to track initial auto-apply

    useEffect(() => {
        refreshToken();
        getUserCompany();
    }, []);

    useEffect(() => {
        if(cid){
            checkPageAccess();
        }
    }, [cid]);

    const incrementLoading = () => setLoadingCount((prev) => prev + 1);
    const decrementLoading = () => setLoadingCount((prev) => Math.max(prev - 1, 0));

    useEffect(() => {
        setPopupOpen(loadingCount > 0);
    }, [loadingCount]);

    // Effect to auto-apply filters on initial load if selectedCompany is present from initialFilters
    useEffect(() => {
        if (
            isInitialPageLoadForAutoApply.current &&
            (role >= 3 || (role <= 2 && initialFilters?.selectedCompany)) &&
            selectedCompany && // Ensure state is also updated (should match initialFilters)
            token &&
            cid &&
            callPassBrandedCallingAccess &&
            userCallPassBrandedCallingAccess
        ) {
            console.log("Initial load with selectedCompany, applying filters automatically.");
            handleApplyFilters();
            isInitialPageLoadForAutoApply.current = false; // Prevent re-triggering
        }
    }, [
        initialFilters?.selectedCompany, // Dependency on the prop value
        selectedCompany, // Dependency on the state value
        token,
        cid,
        role,
        callPassBrandedCallingAccess,
        userCallPassBrandedCallingAccess,
    ]);
    const refreshToken = async () => {
        try {
            const response = await axios.get(`${baseUrl}/token`);
            
            setToken(response.data.accessToken);
            const decoded = jwt_decode(response.data.accessToken);
            console.log(decoded);
            setName(decoded.name);
            setRole(decoded.role)
            setExpire(decoded.exp);
            setCid(decoded.cid);
            seTimeZone(decoded.timezone);
        } catch (error) {

            if (error.response) {
                // setError("Unauthorized");
                navigate("/");
                window.location.reload();
            }
        }
    }
    
    
    const checkPageAccess = async () => {
        try {
            incrementLoading();
            // Fetch all required data            
            const customerDigitMappingResponse = await axios.get(`${baseUrl}/check-company-e911-access/${cid}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            const userAccessResponse = await axiosJWT.get(`${baseUrl}/user-access`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            
            const callPassBrandedCallingSwitch = customerDigitMappingResponse.data.call_pass_branded_calling_switch;
            const userCallPassBrandedCallingSwitch = userAccessResponse.data.user_call_pass_branded_calling_switch;
            decrementLoading();
            setAccess(userAccessResponse.data.results);
            // Conditional check for access
            if (
                callPassBrandedCallingSwitch >= 1 &&
                userCallPassBrandedCallingSwitch >= 1
            ) {
                setUserCallPassBrandedCallingAccess(userCallPassBrandedCallingSwitch >= 1);
                setCallPassBrandedCallingAccess(callPassBrandedCallingSwitch >= 1);
                // Proceed with page logic
            } else {
                navigate('/dashboard');
            }
        } catch (error) {
            console.error("Error checking page access:", error);
            navigate('/dashboard'); // Redirect in case of any error
        }
    };

    const getUserCompany = async () => {
        
        const response = await axiosJWT.get(`${baseUrl}/active-user-company`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        const company = response.data.filter(item => item.id !== 1);
        // company.shift();
        // console.log(response.data);
        setCompany(company);
    }

    const formatDateToYYYYMMDD = (date) => {
        if (!date) return ''; // Handle null or undefined dates
        const d = new Date(date);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        const day = String(d.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    // Timezone mapping from abbreviation to IANA timezone identifier
    const timezoneMap = {
        'PST': 'America/Los_Angeles',
        'PDT': 'America/Los_Angeles',
        'MST': 'America/Denver',
        'MDT': 'America/Denver',
        'CST': 'America/Chicago',
        'CDT': 'America/Chicago',
        'EST': 'America/New_York',
        'EDT': 'America/New_York',
        'UTC': 'UTC',
        'GMT': 'UTC'
    };

    // Convert user's local date/time to UTC
    const convertToUTC = (date, time, userTimezone) => {
        if (!date || !time) return { utcDate: '', utcTime: '' };

        // If user timezone is UTC, no conversion needed
        if (userTimezone === 'UTC' || userTimezone === 'GMT') {
            return {
                utcDate: formatDateToYYYYMMDD(date),
                utcTime: time
            };
        }

        const ianaTimezone = timezoneMap[userTimezone] || userTimezone;

        // Create a date string in user's timezone
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const dateTimeString = `${year}-${month}-${day}T${time}:00`;

        // Create date object and convert to UTC
        const localDate = new Date(dateTimeString);

        // Get the offset for the user's timezone
        const formatter = new Intl.DateTimeFormat('en-US', {
            timeZone: ianaTimezone,
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: false
        });

        // Parse the formatted date in user's timezone to get offset
        const parts = formatter.formatToParts(localDate);
        const getPart = (type) => parts.find(p => p.type === type)?.value || '00';

        // Create a date in the user's timezone
        const userTzDate = new Date(
            `${getPart('year')}-${getPart('month')}-${getPart('day')}T${getPart('hour')}:${getPart('minute')}:${getPart('second')}`
        );

        // Calculate offset between local browser time and user's timezone
        const offsetMs = localDate.getTime() - userTzDate.getTime();

        // Apply offset to get UTC time
        const utcDateTime = new Date(localDate.getTime() + offsetMs);

        const utcYear = utcDateTime.getUTCFullYear();
        const utcMonth = String(utcDateTime.getUTCMonth() + 1).padStart(2, '0');
        const utcDay = String(utcDateTime.getUTCDate()).padStart(2, '0');
        const utcHour = String(utcDateTime.getUTCHours()).padStart(2, '0');
        const utcMinute = String(utcDateTime.getUTCMinutes()).padStart(2, '0');

        return {
            utcDate: `${utcYear}-${utcMonth}-${utcDay}`,
            utcTime: `${utcHour}:${utcMinute}`
        };
    };

    // Convert UTC date/time to user's local timezone for display
    const convertFromUTC = (utcDateStr, utcTimeStr, userTimezone) => {
        if (!utcDateStr) return { localDate: '', localTime: '' };

        // If user timezone is UTC, no conversion needed
        if (userTimezone === 'UTC' || userTimezone === 'GMT') {
            return {
                localDate: utcDateStr,
                localTime: utcTimeStr || '00:00'
            };
        }

        const ianaTimezone = timezoneMap[userTimezone] || userTimezone;
        const timeStr = utcTimeStr || '00:00';
        const utcDateTime = new Date(`${utcDateStr}T${timeStr}:00Z`);

        // Format the UTC date in user's timezone
        const formatter = new Intl.DateTimeFormat('en-US', {
            timeZone: ianaTimezone,
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
        });

        const parts = formatter.formatToParts(utcDateTime);
        const getPart = (type) => parts.find(p => p.type === type)?.value || '00';

        return {
            localDate: `${getPart('year')}-${getPart('month')}-${getPart('day')}`,
            localTime: `${getPart('hour')}:${getPart('minute')}`
        };
    };

    // Format UTC datetime to user's timezone for display
    const formatDateTimeToUserTimezone = (utcDateTimeStr, userTimezone) => {
        if (!utcDateTimeStr) return '';

        const ianaTimezone = timezoneMap[userTimezone] || userTimezone || 'UTC';

        try {
            const utcDate = new Date(utcDateTimeStr);
            if (isNaN(utcDate.getTime())) return utcDateTimeStr;

            const formatter = new Intl.DateTimeFormat('en-US', {
                timeZone: ianaTimezone,
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                hour12: false
            });

            const parts = formatter.formatToParts(utcDate);
            const getPart = (type) => parts.find(p => p.type === type)?.value || '00';

            return `${getPart('year')}-${getPart('month')}-${getPart('day')} ${getPart('hour')}:${getPart('minute')}:${getPart('second')}`;
        } catch (error) {
            console.error('Error formatting date:', error);
            return utcDateTimeStr;
        }
    };

    const handlePageChange  = (pageNumber) => {
        // console.log(`active page is ${pageNumber}`);
        setPage(pageNumber);
        fetchSummaryData(pageNumber, startDate, endDate, startTime, endTime, selectedEntity, selectedCompany, selectedDisplayIdentity, selectedOrigationNumber);
    }

    const fetchFilterOptions = async (startDate, endDate, startTime, endTime, selectedCompany,selectedEntity, selectedDisplayIdentity, selectedOrigationNumber, timezone ) => {
        incrementLoading();
        const tz = timezone || displayTimezone;
        try {
            // Convert user's local date/time to UTC before sending to API
            const utcStart = convertToUTC(startDate, startTime, tz);
            const utcEnd = convertToUTC(endDate, endTime, tz);

            const response = await axiosJWT.get(`${baseUrl}/call-pass-detail-filters`, {
                params: {
                    startDate: utcStart.utcDate,
                    endDate: utcEnd.utcDate,
                    startTime: utcStart.utcTime,
                    endTime: utcEnd.utcTime,
                    company: selectedCompany,
                entity: selectedEntity,
                displayIdentity: selectedDisplayIdentity,
                origationNumber: selectedOrigationNumber},
                headers: { Authorization: `Bearer ${token}` }
            });
            setEntityOptions(response.data.filter.entities || []);
            setDisplayIdentityOptions(response.data.filter.displayIdentities || []);
            setOrigationNumberOptions(response.data.filter.originationNumbers || []);

            
            console.log("Fetched filter options based on date/time range.");
        } catch (error) {
            console.error("Error fetching filter options:", error);
            // Handle error (e.g., show a notification)
        }finally{
            decrementLoading();
        }
    };

    const fetchSummaryData = async (page, startDate, endDate, startTime, endTime, entity, company, displayIdentity, origationNumber, timezone)     => {
        incrementLoading();
        const tz = timezone || displayTimezone;
        try {
            // Convert user's local date/time to UTC before sending to API
            const utcStart = convertToUTC(startDate, startTime, tz);
            const utcEnd = convertToUTC(endDate, endTime, tz);

            const response = await axiosJWT.get(`${baseUrl}/call-pass-detail`, {
                params: {
                    page: page,
                    startDate: utcStart.utcDate,
                    endDate: utcEnd.utcDate,
                    startTime: utcStart.utcTime,
                    endTime: utcEnd.utcTime,
                    entity: entity,
                    company: company,
                    displayIdentity: displayIdentity,
                    origationNumber: origationNumber },
                headers: { Authorization: `Bearer ${token}` }
            });
            setSummaryData(response.data.summary || []); // Data for the current page
            setTotalItem(response.data.totalCount || 0); // Ensure your API returns a total count of records

            // Placeholder data
            // setSummaryData([
            //     {id: 1, entity: 'Entity A', displayId: 'Display X', origNum: '111', calls: 100},
            //     {id: 2, entity: 'Entity B', displayId: 'Display Y', origNum: '222', calls: 150},
            // ]);            
            console.log("Fetched summary data based on all filters.");
        } catch (error) {
            console.error("Error fetching summary data:", error);
            // Handle error
        }finally{
            decrementLoading();
        }
    };

    const handleExportCSV = async(e) => {
        e.preventDefault();
        incrementLoading();
        try {
            // Convert user's local date/time to UTC before sending to API
            const utcStart = convertToUTC(startDate, startTime, displayTimezone);
            const utcEnd = convertToUTC(endDate, endTime, displayTimezone);

            const response = await axiosJWT.get(`${baseUrl}/call-pass-detail`, {
                params: {
                    startDate: utcStart.utcDate,
                    endDate: utcEnd.utcDate,
                    startTime: utcStart.utcTime,
                    endTime: utcEnd.utcTime,
                    company: selectedCompany,
                    type: 2,
                    entity: selectedEntity,
                    displayIdentity: selectedDisplayIdentity,
                    origationNumber: selectedOrigationNumber
                },
                headers: { Authorization: `Bearer ${token}` }
            });

            const list = response.data.summary;

            if (list && list.length > 0) {
                // Map data to ensure correct headers and order in Excel
                const mappedData = list.map(item => ({
                    [`Date/Time (${displayTimezone})`]: formatDateTimeToUserTimezone(item.UTC, displayTimezone),
                    "Calling Entity": item.Calling_Entity,
                    "Entity": item.Entity,
                    "Display Identity": item.Display_Identity,
                    "Origination Number": item.Origination_Number,
                    "Destination Number": item.Destination_Number,
                    "Claims Passed": item.Claims_Passed,
                    "TSP": item.TSP
                }));
                const ws = XLSX.utils.json_to_sheet(mappedData);
                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws, "CallPassDetails");
                XLSX.writeFile(wb, "CallPassDetailsReport.xlsx");
            } else {
                alert("No data available to export for the selected filters.");
            }
        }catch (error) {
            console.error("Error fetching filter options:", error);
            
            // Handle error (e.g., show a notification)
        }finally{
            decrementLoading();
        }
    }

    const handleApplyFilters = () => {
        // Commit the pending timezone selection on Apply
        setDisplayTimezone(pendingDisplayTimezone);
        setPage(1);
        fetchSummaryData(1, startDate, endDate, startTime, endTime, selectedEntity, selectedCompany, selectedDisplayIdentity, selectedOrigationNumber, pendingDisplayTimezone);
        fetchFilterOptions(startDate, endDate, startTime, endTime, selectedCompany, selectedEntity, selectedDisplayIdentity, selectedOrigationNumber, pendingDisplayTimezone);
    };

    const handleClearFilters = () => {
        setStartDate(getYesterday());
        setEndDate(new Date());
        setStartTime("00:00");
        setEndTime("23:59");
        setSelectedCompany("");
        setSelectedEntity("");
        setSelectedDisplayIdentity("");
        setSelectedOrigationNumber("");
        setDisplayTimezone('UTC');
        setPendingDisplayTimezone('UTC');
        setPage(1);
        fetchSummaryData(1, getYesterday(), new Date(), "00:00", "23:59", "", "", "", "", 'UTC');
    };

    // Effect for selectedEntity change, if primary filters are active
    useEffect(() => {
        if (isInitialMountEntity.current) {
            isInitialMountEntity.current = false;
            return; // Skip on initial mount
        }

        // Only proceed if primary filters are active ("showClearButton" is true) 
        // and page access/auth state is confirmed.
        if (showClearButton && cid && callPassBrandedCallingAccess && userCallPassBrandedCallingAccess && token) {
            setPage(1);
            // Reset dependent filters first
            setSelectedDisplayIdentity("");
            setSelectedOrigationNumber("");

            // Then fetch options and data with the new entity and BLANKED dependent filters
            fetchFilterOptions(startDate, endDate, startTime, endTime, selectedCompany, selectedEntity, "", "");
            fetchSummaryData(1, startDate, endDate, startTime, endTime, selectedEntity, selectedCompany, "", "");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps 
    }, [selectedEntity]); // Trigger only when selectedEntity changes

    // Effect for selectedDisplayIdentity change, if primary filters are active
    useEffect(() => {
        if (isInitialMountDisplayIdentity.current) {
            isInitialMountDisplayIdentity.current = false;
            return; // Skip on initial mount
        }
        if (showClearButton && cid && callPassBrandedCallingAccess && userCallPassBrandedCallingAccess && token) {
            setPage(1);

            setSelectedOrigationNumber("");
            
            fetchFilterOptions(startDate, endDate, startTime, endTime, selectedCompany, selectedEntity, selectedDisplayIdentity, "");
            fetchSummaryData(1, startDate, endDate, startTime, endTime, selectedEntity,selectedCompany, selectedDisplayIdentity, ""); // Removed explicit call to let useEffect handle data fetching.
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedDisplayIdentity]); // Trigger only when selectedDisplayIdentity changes

    // Effect for selectedOrigationNumber change, if primary filters are active
    useEffect(() => {  
        if (isInitialMountOrigationNumber.current) {
            isInitialMountOrigationNumber.current = false;
            return; // Skip on initial mount
        }  
        if (showClearButton && cid && callPassBrandedCallingAccess && userCallPassBrandedCallingAccess && token) {
            setPage(1);
            fetchFilterOptions(startDate, endDate, startTime, endTime, selectedCompany, selectedEntity, selectedDisplayIdentity, selectedOrigationNumber);
            fetchSummaryData(1, startDate, endDate, startTime, endTime, selectedEntity,selectedCompany, selectedDisplayIdentity, selectedOrigationNumber); // Removed explicit call to let useEffect handle data fetching.
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedOrigationNumber]); // Trigger only when selectedOrigationNumber changes
    const isDefaultDate = (date, defaultDateFunc) => {
        const defaultDate = defaultDateFunc();
        return date.getFullYear() === defaultDate.getFullYear() &&
               date.getMonth() === defaultDate.getMonth() &&
               date.getDate() === defaultDate.getDate();
    };
 
    const showClearButton = !isDefaultDate(startDate, getYesterday) ||
                            !isDefaultDate(endDate, () => new Date()) ||
                            startTime !== "00:00" ||
                            endTime !== "23:59" ||
                            selectedCompany !== "" ||
                            selectedEntity !== "" ||
                            selectedDisplayIdentity !== "" ||
                            selectedOrigationNumber !== ""; 
 
    const gotoSwitchScreen = (e, type) => {
        e.preventDefault();
        
        const navigationState = {
            initialFilters: { // Current filter values from Summary page
                startDate: startDate.toISOString(), // Convert Date objects to string
                endDate: endDate.toISOString(),
                startTime,
                endTime,
                selectedCompany,
                selectedEntity,
                selectedDisplayIdentity,
                selectedOrigationNumber,
                displayTimezone,
            }
        };
        navigate("/call-pass-summary", { state: navigationState});
        
    }
    const axiosJWT = axios.create();
 
    axiosJWT.interceptors.request.use(async (config) => {
        const currentDate = new Date();
        if (expire * 1000 < currentDate.getTime()) {
            const response = await axios.get(`${baseUrl}/token`);
            config.headers.Authorization = `Bearer ${response.data.accessToken}`;
            setToken(response.data.accessToken);
            const decoded = jwt_decode(response.data.accessToken);
            setName(decoded.name);
            setRole(decoded.role)
            setExpire(decoded.exp);
            setCid(decoded.cid);
            seTimeZone(decoded.timezone);
        }
        return config;
    }, (error) => {
        return Promise.reject(error);
    });
 
    
 
    return (
        <div className="panelbox">
           <Navbar  token={token} access = {access}/>
            <div className="right-panel">
            <Header name={name} />
            {popupOpen && (
                     <Loader /> 
                ) }
                <div className="content-page">
                    <div className="row">
                        <div className="col-4">
                            <div className="left-title">
                                <h1>Call Pass Details</h1>
                            </div>
                        </div>
                        <div className="col-8 inventory-btn">
                            <div className="addnew-button top-right-buttons">
                                <a href="#" style={{marginLeft: '10px',paddingBottom: '15px'}} onClick={(e) => gotoSwitchScreen(e)}>Call Pass Summary</a>
                                <Link to="/dashboard"><span>&larr;</span>Dashboard</Link>
                                {summaryData.length > 0 && <div className="export-btn newrow"><a className="newrow" onClick={handleExportCSV} href="#">Export</a></div>}

                            </div>
                        </div>
                        <div className="col-12">                            
                            <label>*Preliminary data - Not to be used for billing</label>
                        </div>
                    </div>
                    {/* Filter Section */}
                    <div className="common-white-shadow-background setting-section">
                        <div className="row filter-section align-items-end"> {/* All filters and buttons in this single row, align items to bottom */}
                             <div className="col-md-2">
                                <label>Start Date ({displayTimezone}):</label>
                                <DatePicker selected={startDate} onChange={(date) => setStartDate(date)} className="form-control" dateFormat="MM/dd/yyyy" />
                            </div>
                            <div className="col-md-2">
                                <label>Start Time ({displayTimezone}):</label>
                                <input type="time" value={startTime} onChange={(e) => setStartTime(e.target.value)} className="form-control" />
                            </div>
                            <div className="col-md-2">
                                <label>End Date ({displayTimezone}):</label>
                                <DatePicker selected={endDate} onChange={(date) => setEndDate(date)} className="form-control" dateFormat="MM/dd/yyyy" />
                            </div>
                            <div className="col-md-2">
                                <label>End Time ({displayTimezone}):</label>
                                <input type="time" value={endTime} onChange={(e) => setEndTime(e.target.value)} className="form-control" />
                            </div>
                            <div className="col-md-2">
                                <label>Time Zone:</label>
                                <select value={pendingDisplayTimezone} onChange={(e) => setPendingDisplayTimezone(e.target.value)} className="form-control">
                                    <option value="UTC">UTC</option>
                                    {timeZone && timeZone !== 'UTC' && timeZone !== 'GMT' && (
                                        <option value={timeZone}>{timeZone}</option>
                                    )}
                                </select>
                            </div>
                            {role <=2 &&<div className="col-md-2">
                                <label>Company:</label>
                                <select value={selectedCompany} onChange={(e) => setSelectedCompany(e.target.value)} className="form-control">
                                <option value="" >Company</option>
                                    {company.map(option => (
                                        <option key={option.id} value={option.id}>{option.cname}</option>
                                    ))}
                                </select>
                            </div>}
                            <div className="col-md-2" style={{marginTop:"23px"}}> {/* Column for buttons */}
                                 {/* This inner div helps align buttons correctly, especially with align-items-end on the row */}
                                 {/* No explicit label needed here as align-items-end handles vertical positioning relative to other columns */}
                                 <div style={{ display: 'flex', justifyContent: 'flex-start', paddingBottom: '10px' }}> {/* Adjust paddingBottom to match input's effective bottom margin */}
                                 <button
                                         onClick={handleApplyFilters}
                                         className="search-btn"
                                         style={{
                                             width: 'auto', // Override .search-btn width: max-content (if needed for consistency)
                                             display: 'inline-block', // Override .search-btn display: block
                                             marginLeft: '0', // Override .search-btn margin-left: AUTO
                                             marginRight: '10px' // Ensure no extra right margin
                                         }}
                                     >
                                         Apply
                                     </button>
                                     {showClearButton && (
                                         <button
                                             onClick={handleClearFilters}
                                             className="search-btn clear-btn"
                                             style={{
                                                 marginRight: '10px',
                                                 width: 'auto', // Override .clear-btn fixed width
                                                 display: 'inline-block', // Override .search-btn display: block
                                                 marginLeft: '0' // Override .search-btn margin-left: AUTO
                                             }}
                                         >
                                             Clear
                                         </button>
                                     )}
                                     
                                 </div>
                             </div>
                        </div>
                        
                    </div>
                    <div className="common-white-shadow-background setting-section">
                        <div className="row filter-section align-items-end"> {/* All filters and buttons in this single row, align items to bottom */}
                             
                             <div className="col-md-2">
                                 <label>Entity:</label>
                                 <select value={selectedEntity} onChange={(e) => setSelectedEntity(e.target.value)} className="form-control">
                                     <option value="">All Entities</option>
                                     {entityOptions.map((option,index) => (
                                         <option key={index} value={option}>{option}</option>
                                     ))}
                                 </select>
                             </div>
                             <div className="col-md-2">
                                 <label>Display Identity:</label>
                                 <select value={selectedDisplayIdentity} onChange={(e) => setSelectedDisplayIdentity(e.target.value)} className="form-control">
                                     <option value="">All Display Identities</option>
                                     {displayIdentityOptions.map((option,index) => (
                                         <option key={index} value={option}>{option}</option>
                                     ))}
                                 </select>
                             </div>
                             <div className="col-md-2">
                                 <label>Origination Number:</label>
                                 <select value={selectedOrigationNumber} onChange={(e) => setSelectedOrigationNumber(e.target.value)} className="form-control">
                                     <option value="">All Origination Numbers</option>
                                     {origationNumberOptions.map((option,index) => (
                                         <option key={index} value={option}>{option}</option>
                                     ))}
                                 </select>
                             </div>
                             
                         </div>
                    </div>
                    {/* Summary Data Display Section */}
                    <div className="common-white-shadow-background setting-section" style={{marginTop: '20px'}}>
                        <h3>Details Results</h3>
                        {summaryData.length > 0 ? (
                            <table className="tablebox search-result-table">
                                <thead>
                                    <tr>
                                        <th>Date/Time ({displayTimezone})</th>
                                        <th>Calling Entity</th>
                                        <th>Entity</th>
                                        <th>Display Identity</th>
                                        <th>Origination Number</th>
                                        <th>Destination Number</th>
                                        <th>Claims Passed
                                            <td><small>(N = Name, L = Logo, C = Call Reason)</small></td>
                                        </th>
                                        <th>TSP</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {summaryData.map((item, index) => (
                                        <tr key={index}>
                                            <td>{formatDateTimeToUserTimezone(item.UTC, displayTimezone)}</td>
                                            <td>{item.Calling_Entity}</td>
                                            <td>{item.Entity}</td>
                                            <td>{item.Display_Identity}</td>
                                            <td>{item.Origination_Number}</td>
                                            <td>{item.Destination_Number}</td>
                                            <td>{item.Claims_Passed}</td>
                                            <td>{item.TSP}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        ) : (
                            <p>No data available for the selected filters.</p>
                        )}
                    </div>
                    {totalItem > 50 && (<Pagination
                                  activePage={page}
                                  itemsCountPerPage={50}
                                  totalItemsCount={totalItem}
                                  pageRangeDisplayed={5}
                                  onChange={handlePageChange.bind(this)}
                                />)}
                </div>
            </div>            
        </div>
    )
}
 
export default CallPassBrandedCallingDetails